





























































































































































import Vue from "vue";
import { Produkt } from "@megarax/client/src/resources/plm/Produkt";
import ResourceItemReference from "@/components/resource/ResourceItemReference";
import { TextEntry } from "@/components/sheet/SheetEntries";
import DefaultRevisionSheet from "@/components/DefaultRevisionSheet.vue";
import { createComponent } from "@vue/composition-api";

export default createComponent({
  components: {
    TextEntry,
    DefaultRevisionSheet,
  },
  name: "ProduktSheet",
  props: {
    value: {
      required: true,
      type: Produkt,
    },
  },
  filters: {
    BooleanValue: (value: boolean) => (value ? "Tak" : "Nie"),
  },
  setup(props, ctx) {
    return {};
  },
});
